import React, { useState, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FiMapPin,
  FiChevronDown,
  FiSliders,
  FiSearch,
  FiMap,
  FiList,
} from "react-icons/fi";
import FilterScreenModel from "../FilterScreenModel/FilterScreenModel";
import NewHomeFilterModel from "../FilterScreenModel/NewHomeFilterModel";
import Layout2 from "../../../Layouts/Layout2";
import { categoryTabs } from "../../NewApartments/data/mockData";
const COUNTRY_CRUMB = "NGA";

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function stripTrailingCountry(fullAddress, countryLabel) {
  if (!fullAddress || !countryLabel) return "";
  let t = fullAddress.trim();
  const suffix = new RegExp(
    `,\\s*${escapeRegExp(countryLabel)}\\s*$`,
    "i"
  );
  t = t.replace(suffix, "").trim().replace(/,$/, "").trim();
  return t;
}

function getSearchLocationFromPathname(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  const searchedIndex = parts.indexOf("searched");
  if (searchedIndex === -1) return null;
  const raw = parts[searchedIndex + 1];
  if (raw == null || raw === "") return null;
  try {
    const decoded = decodeURIComponent(raw).trim();
    return decoded || null;
  } catch {
    return null;
  }
}

export default function FilterNavTab({
  isNewHomes = false,
  currentTab,
  dataCount = 0,
  locationText,
}) {
  const [activeCategory, setActiveCategory] = useState("New Apartments");
  const [categoryOpen, setCategoryOpen] = useState(false);
  const categoryRef = useRef(null);
  const { pathname } = useLocation();
  const [active, setActive] = useState("list");
  const [IsOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const fromUrl = useMemo(
    () => getSearchLocationFromPathname(pathname),
    [pathname]
  );

  const locationPlaceName = useMemo(() => {
    if (!fromUrl) return null;
    const stripped = stripTrailingCountry(fromUrl, COUNTRY_CRUMB);
    return stripped || null;
  }, [fromUrl]);

  const displayLocation =
    locationPlaceName || locationText || (!fromUrl ? "Nigeria" : fromUrl);

  const safeCount = Number(dataCount ?? 0) || 0;
  const formattedCount = new Intl.NumberFormat().format(safeCount);
  const countNoun = safeCount === 1 ? "property" : "properties";
  const actionText = currentTab === "Rent" ? "for rent in" : `${currentTab} in`;

  const FilterPill = ({ label, icon, dropdownIcon = false }) => {
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2 px-[15px] py-[10px] bg-white border-[1.5px] border-[#EAEAEA] text-[#0009298]!  rounded-full text-base hover:shadow-sm transition "
      >
        <span className="opacity-50">{icon && icon}</span>
        <span className="opacity-50">{label}</span>
        {dropdownIcon && (
          <FiChevronDown size={14} className="opacity-50 ml-6" />
        )}
      </button>
    );
  };

  return (
    <>
      <Layout2>
        <div className="bg-white py-6">
          <div className="flex items-center text-[18px] text-[#000929]  gap-3 mb-6 flex-wrap">
            <span className="hover:text-black hover:underline cursor-pointer opacity-50" onClick={() => navigate(`/${currentTab.toLowerCase()}`)}>
              {currentTab}
            </span>
            <span className="opacity-50">/</span>
            {fromUrl ? (
              <>
                <span className="hover:text-black hover:underline cursor-pointer opacity-50" onClick={() => navigate(`/${currentTab.toLowerCase()}`)}>
                  {COUNTRY_CRUMB}
                </span>
                {locationPlaceName ? (
                  <>
                    <span className="opacity-50">/</span>
                    <span className="flex items-center gap-1 text-blue-600 opacity-1 font-medium min-w-0 break-words">
                      <FiMapPin size={14} className="flex-shrink-0" />
                      <span className="min-w-0">{locationPlaceName}</span>
                    </span>
                  </>
                ) : null}
              </>
            ) : (
              <span className="flex items-center gap-1 text-blue-600 opacity-1 font-medium min-w-0 break-words">
                <FiMapPin size={14} className="flex-shrink-0" />
                <span className="min-w-0">{displayLocation}</span>
              </span>
            )}
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-6">
            {locationPlaceName ? (
              <FilterPill icon={<FiMapPin />} label={`${displayLocation.replace(", Nigeria", '').trim()}, ${COUNTRY_CRUMB}`} />
            ) : (
              <FilterPill icon={<FiMapPin />} label={`${COUNTRY_CRUMB}`} />
            )}

            <FilterPill label="Any Price" dropdownIcon={true} />

            <FilterPill label="All types" dropdownIcon={true} />

            <FilterPill label="Any beds" dropdownIcon={true} />

            <FilterPill label="Any baths" dropdownIcon={true} />

            <button
              className="flex items-center gap-2 px-[22px] py-[10px] bg-white border border-gray-200 rounded-full text-base font-medium hover:shadow-sm transition"
              onClick={() => setIsOpen(true)}
            >
              <FiSliders />
              More Filters
            </button>

            <button
              className="flex items-center gap-2 px-[40px] py-[10px] bg-[#097FE6] hover:bg-blue-500 text-white rounded-full text-base font-semibold transition"
              onClick={() => setIsOpen(true)}
            >
              <FiSearch />
              Search
            </button>
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="text-gray-700 text-sm">
              <span className="font-semibold text-base text-[#000929]">
                {formattedCount}
              </span>
              <span className="opacity-50">
                {" "}
                {countNoun} {actionText} {displayLocation}
              </span>
            </div>

            <div className="flex items-center gap-3">
              <button className="flex items-center gap-2 px-[22px] py-[12px] bg-white border border-gray-200 rounded-[12px] text-sm hover:shadow-sm transition">
                <span className="opacity-50">Relevance</span>
                <FiChevronDown size={14} className="opacity-50" />
              </button>
              {
                pathname.includes("new-homes") && (<>
                  {/* category dropdown */}
                  <div className="relative" ref={categoryRef}>
                    <button
                      onClick={() => setCategoryOpen((o) => !o)}
                      className="flex items-center gap-2 rounded-xl px-4 py-3 text-base font-medium hover:bg-gray-50 transition whitespace-nowrap"
                      style={{ border: "1.5px solid #EAEAEA", color: "#000929" }}
                    >
                      {activeCategory}
                      <FiChevronDown
                        size={14}
                        className={`transition-transform duration-200 ${categoryOpen ? "rotate-180" : ""}`}
                        style={{ color: "rgba(0,9,41,0.5)" }}
                      />
                    </button>
                    {categoryOpen && (
                      <ul
                        className="absolute left-0 top-full mt-1 bg-white rounded-xl shadow-xl z-50 overflow-hidden min-w-[180px]"
                        style={{ border: "1.5px solid #EAEAEA" }}
                      >
                        {categoryTabs
                          .filter((t) => t.label !== "Explore")
                          .map((tab) => (
                            <li
                              key={tab.label}
                              onClick={() => { setActiveCategory(tab.label); setCategoryOpen(false); }}
                              className="px-4 py-3 text-sm cursor-pointer transition-colors duration-100"
                              style={{
                                color: activeCategory === tab.label ? "#2563eb" : "#000929",
                                background: activeCategory === tab.label ? "#eff6ff" : "#fff",
                                fontWeight: activeCategory === tab.label ? 600 : 400,
                              }}
                              onMouseEnter={(e) => { if (activeCategory !== tab.label) e.currentTarget.style.background = "#f9fafb"; }}
                              onMouseLeave={(e) => { if (activeCategory !== tab.label) e.currentTarget.style.background = "#fff"; }}
                            >
                              {tab.label}
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                </>)
              }

              <div className="relative flex items-center w-[112px] h-[48px] p-[4px] gap-[4px] bg-[#F3F6F9] rounded-[13px]">
                <div
                  className={`absolute top-[4px] bottom-[4px] w-[calc(50%-6px)] bg-white rounded-[9px] shadow-sm transition-all duration-300 ${active === "list" ? "left-[4px]" : "left-[calc(50%+2px)]"
                    }`}
                />

                <button
                  onClick={() => setActive("list")}
                  className={`relative z-10 flex-1 flex items-center justify-center rounded-[9px] transition ${active === "list" ? "text-black" : "text-gray-500"
                    }`}
                >
                  <FiList size={20} />
                </button>

                <button
                  onClick={() => setActive("map")}
                  className={`relative z-10 flex-1 flex items-center justify-center rounded-[9px] transition ${active === "map" ? "text-black" : "text-gray-500"
                    }`}
                >
                  <FiMap size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Layout2>

      {!isNewHomes && <FilterScreenModel
        setIsOpen={setIsOpen}
        IsOpen={IsOpen}
        currentTab={currentTab}
      />}

      {isNewHomes && <NewHomeFilterModel
        setIsOpen={setIsOpen}
        IsOpen={IsOpen}
        currentTab={currentTab}
        dataCount={dataCount}
      />}


    </>
  );
}
